import { Contact } from "views/website/contact";
import { Pricing } from "views/website/pricing";
import { Privacy } from "views/website/privacy";
import { Terms } from "views/website/terms";

const Routes = [
  {
    path: "/app/contact",
    view: Contact,
    layout: "home",
    title: "Contact",
  },
  {
    path: "/app/pricing",
    view: Pricing,
    layout: "home",
    title: "Pricing",
  },
  {
    path: "/app/privacy",
    view: Privacy,
    layout: "home",
    title: "Privacy Policy",
  },
  {
    path: "/app/terms",
    view: Terms,
    layout: "home",
    title: "Terms & Conditions",
  },
];

export default Routes;
